"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var index_1 = require("../../actions/index");
var GridFilterForm_1 = __importDefault(require("./GridFilterForm"));
var react_router_dom_1 = require("react-router-dom");
var mapStateToProps = function (_a, _b) {
    var grid = _a.grid;
    var gridname = _b.grid, initialValues = _b.initialValues, children = _b.children;
    return ({
        form: gridname + 'Filter',
        initialValues: Object.assign({}, initialValues || {}, grid[gridname] && grid[gridname].filter),
        children: react_1["default"].Children.map(children, function (child) {
            return react_1["default"].isValidElement(child) && typeof child.type === 'function'
                ? react_1["default"].cloneElement(child, { grid: gridname })
                : child;
        })
    });
};
var mapDispatchToProps = function (dispatch, _a) {
    var grid = _a.grid, initialValues = _a.initialValues, replace = _a.replace, location = _a.location;
    return ({
        // @ts-ignore
        onSubmit: function (data) { return dispatch((0, index_1.applyFilter)(data, grid)(replace, location)); },
        // @ts-ignore
        clearFilter: function () { return dispatch((0, index_1.applyFilter)(initialValues || {}, grid)(replace, location)); }
    });
};
var GridFilterContainer = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(GridFilterForm_1["default"]);
var GridFilterWrapper = function (_a) {
    var grid = _a.grid, rest = __rest(_a, ["grid"]);
    var replace = (0, react_router_dom_1.useHistory)().replace;
    var location = (0, react_router_dom_1.useLocation)();
    return react_1["default"].createElement(GridFilterContainer, __assign({ grid: grid, replace: replace, location: location }, rest));
};
exports["default"] = GridFilterWrapper;
